<template>
  <transition name="slide-fade">
    <div class="w-100 alert" :class="'alert-' + type" v-if="show" style="position: fixed">
      <font-awesome-icon icon="check-circle" size="lg" class="icon" v-if="type == 'success'"/>
      <font-awesome-icon icon="exclamation-circle" size="lg" class="icon" v-if="type == 'danger'"/>
      {{ message }}
      <ul class="mt-2" v-if="items.length > 0">
        <li v-for="(item, index) in items" :key="index">{{ item }}</li>
      </ul>
    </div>
  </transition>
</template>

<style lang="scss">
@import "../assets/main.scss";

.alert {
  z-index: 9999;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter {
  transform: translateY(20px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>

<script>
export default {
  name: 'Alert',
  data() {
    return {
      show: false,
      message: '',
      items: [],
      type: 'success',
      timeout: null,
    };
  },
  methods: {
    showAlert(options) {
      clearTimeout(this.timeout);
      this.type = options.type;
      this.message = options.message;
      this.items = options.items || [];
      this.show = true;
      this.timeout = setTimeout(() => {
        this.show = false;
      }, 3000);
    },
  },
};
</script>
